import { Component, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { PageBase } from 't4core';

@Component({
  selector: 'FleetAvailability',
  templateUrl: './FleetAvailability.html',
})
export class FleetAvailabilityComponent extends PageBase {
  private _fromDate: moment.Moment = moment().startOf('month');
  private _toDate: moment.Moment = moment().endOf('month');

  public get fromDate(): moment.Moment { return this._fromDate; }
  public set fromDate(value: moment.Moment) { this._fromDate = value; }

  public get toDate(): moment.Moment { return this._toDate; }
  public set toDate(value: moment.Moment) { this._toDate = value; }

  public async loadData() {
    this.fromDate = this.fromDate.clone();
  }

  constructor(el: ElementRef) {
    super(el, 'FleetAvailability');
  }
}
